// src/pages/SomethingWentWrong.js
import React from 'react';

const SomethingWentWrong = () => (
  <div style={{ textAlign: 'center', padding: '2rem' }}>
    <h1>🚫 Something Went Wrong</h1>
    <p>The server encountered an error. Please try again later.</p>
  </div>
);

export default SomethingWentWrong;
